import { alpha } from '@mui/material';
export const MuiFormHelperText = {
    styleOverrides: {
        root: ({ theme }: { theme: any }) => {
            return {
                fontStyle: 'italic',
                fontSize: '12px',
                lineHeight: theme.size.lineHeight,
                color: alpha(theme.palette.text.primary, 0.64),
            };
        },
    },
};
